import React from 'react';
import { fmtdate, fmtamount, flagchipclass } from './TableLine';

const FLAGMEANINGS: any = {
  ownerspend: "payment to / bill in the name of the shareholder, decide company vs shareholder account",
  novoucher: "no supporting document",
  tip: "receipt lower than debit, handwritten tip",
  alias: "bank merchant differs from supplier on document",
  datedrift: "document date differs from bank date",
  split: "one document covers several lines",
  quoteonly: "only a quotation",
  nottaxinv: "not a valid tax invoice",
  missingtaxinv: "payment advice without the invoice",
  recharge: "cost to be recovered",
  prepaid: "covers a future period",
  contra: "transfer between own accounts",
  income: "receipt from a customer",
  unclearnature: "cannot tell what was bought",
};

const LineForm = ({ mode, setmode, formdata, setformdata, saveline, ledgerdata, ledgermap }: any) => {
  if (mode != "viewline" && mode != "editline" && mode != "flagline") return null;

  let title = "Line " + formdata.linenumber;
  if (mode == "editline") title = "Edit ledger · line " + formdata.linenumber;
  if (mode == "flagline") title = "Flag line " + formdata.linenumber;

  const flagrows = [];
  for (let f = 0; formdata.flags && f < formdata.flags.length; f++) {
    const code = formdata.flags[f];
    flagrows.push(<div key={code}><span className={flagchipclass(code)}>{code}</span> {FLAGMEANINGS[code] || ""}</div>);
  }

  const ledgeroptions = [];
  for (let i = 0; i < ledgerdata.length; i++) {
    const ledger = ledgerdata[i];
    ledgeroptions.push(<option key={ledger._id} value={ledger.ledgername}>{ledger.ledgername} · {ledger.tallygroup}</option>);
  }

  const amount = fmtamount(formdata.debit) ? fmtamount(formdata.debit) + " Dr" : fmtamount(formdata.credit) + " Cr";

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-content-wide">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={() => setmode(null)}>&times;</button>
        </div>

        <table className="detail">
          <tbody>
            <tr><th>Bank</th><td>{formdata.bankaccount} · {fmtdate(formdata.bankdate)} · {amount}</td></tr>
            <tr><th>Narration</th><td>{formdata.narration}</td></tr>
            <tr><th>Voucher</th><td>{formdata.voucherref} {formdata.vouchertype} {formdata.vendor} {fmtdate(formdata.voucherdate)} {fmtamount(formdata.voucheramount)}</td></tr>
            <tr><th>Difference</th><td>{fmtamount(formdata.difference)} {formdata.differencereason}</td></tr>
            <tr><th>Ledger</th><td>suggested: {formdata.suggestedledger} · final: {formdata.finalledger} ({ledgermap[formdata.finalledger] || ""})</td></tr>
            <tr><th>VAT</th><td>{formdata.vatstatus} {formdata.inputvat != null ? "· input VAT " + fmtamount(formdata.inputvat) : ""}</td></tr>
            <tr><th>Confidence</th><td><span className={"chip chip-" + formdata.confidence}>{formdata.confidence}</span> · balance check {formdata.balancecheck}</td></tr>
            <tr><th>AI flags</th><td>{flagrows.length > 0 ? flagrows : "none"}</td></tr>
            <tr><th>AI notes</th><td>{formdata.ainotes}</td></tr>
            <tr><th>Review</th><td><span className={"chip chip-" + formdata.reviewstatus}>{formdata.reviewstatus}</span> {formdata.revieweremail} {formdata.reviewercomment}</td></tr>
          </tbody>
        </table>

        {mode != "viewline" && (
          <form onSubmit={(e) => { e.preventDefault(); saveline(); }}>
            {mode == "editline" && (
              <div className="fg">
                <label>Ledger</label>
                <select value={formdata.ledger} onChange={(e) => setformdata({ ...formdata, ledger: e.target.value })}>
                  {ledgeroptions}
                </select>
              </div>
            )}
            <div className="fg">
              <label>Comment{mode == "flagline" ? " (required)" : ""}</label>
              <input
                type="text"
                value={formdata.comment}
                onChange={(e) => setformdata({ ...formdata, comment: e.target.value })}
                required={mode == "flagline"}
              />
            </div>
            <button type="submit" className="btn-primary full-width">{mode == "editline" ? "Save ledger" : "Flag line"}</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default LineForm;
